import { connect } from 'react-redux/es';
import { byBaseUrl } from 'core/runtimeConfigReducer';
import HtmlMeta from '../HtmlMeta';
import { byHtmlMeta } from '../modules/htmlMeta';

export const mapStateToProps = (state: any) => ({
  htmlMeta: byHtmlMeta(state),
  baseUrl: byBaseUrl(state),
});

export default connect(mapStateToProps)(HtmlMeta);
